import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const typingApi = {
  /** Pulse: { typing: true|false }. Server throttles true fanout ~2s. */
  signal: (conversationId, typing = true) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/typing`, { typing: !!typing }),
};
